import type { BadgeProps } from '@moia-dev/pace-web'
import {
  Badge,
  Text,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@moia-dev/pace-web'
import type { ReactNode } from 'react'

export const VehicleDrawerStatusBarIndicator = ({
  icon,
  label,
  variant,
  subtitle,
  tooltip,
}: {
  label: string
  icon: BadgeProps['icon']
  variant: BadgeProps['variant']
  subtitle?: ReactNode
  tooltip?: ReactNode
}) => {
  return (
    <Tooltip disabled={!tooltip}>
      <TooltipTrigger>
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            width: 'fit-content',
            margin: 0,
          }}
        >
          <Badge label={label} icon={icon} variant={variant} />
          {subtitle && (
            <Text size="sm" color="reduced">
              {subtitle}
            </Text>
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  )
}
